<template>
  <b-modal id="product-dialog" size="xl" scrollable hide-footer>
    <template v-slot:modal-header="{ close }">
      <h5 class="modal-title font-weight-bold">{{ title }}</h5>
      <button type="button" aria-label="Close" class="close" @click="close()">
        ×
      </button>
    </template>
    <b-row>
      <app-product
        v-for="product in products"
        :key="product.productId"
        :product="product"
        :productType="productType"
        @addProduct="addProductHandler($event.target.value)"
      ></app-product>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import appProduct from './Product.vue'

export default {
  props: ['productType', 'products'],
  computed: {
    ...mapGetters({ dayNo: 'getActiveDayNo' }),
    title() {
      return `Select ${this.productType}`
    }
  },
  methods: {
    ...mapActions(['addDayService']),
    addProductHandler(dayNo) {
      this.addProduct(dayNo)
    }
  },
  components: {
    appProduct
  }
}
</script>
